import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import apiVRR from '../../libs/axios/apis';
import { notify } from '../app/appSlice';
import END_POINTS from '../../services/endpoints';
import { TEditLauncher, TLauncherDetails } from './types';

export const newLaunch = createAsyncThunk(
  'launcher/newLaunch',
  async (videoIds: number[], { getState }) => {
    const currentBrandId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const endPoint = END_POINTS.LAUNCHER.NEW_LAUNCH(currentBrandId);

    const response = await apiVRR('v2').post(endPoint, {
      videoIds
    });

    return response.data;
  }
);

export const editLauncher = createAsyncThunk(
  'launcher/editLauncher',
  async (params: TEditLauncher, { getState }) => {
    const currentBrandId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const launcherId = (getState() as any).launcher.launcherDetails.id;
    const endpointURL = END_POINTS.LAUNCHER.LAUNCHER(
      currentBrandId,
      launcherId
    );
    const response = await apiVRR('v2').patch(endpointURL, params);

    return response.data;
  }
);

export const launch = createAsyncThunk(
  'launcher/launch',
  async (_, { getState, dispatch }) => {
    const currentBrandId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const launcherId = (getState() as any).launcher.launcherDetails.id;
    const endpointURL = END_POINTS.LAUNCHER.LAUNCHER(
      currentBrandId,
      launcherId
    );
    const response = await apiVRR('v2').post(endpointURL);

    if (response.status >= 200) {
      dispatch(notify({ type: 'success' }));
    }

    return response.data;
  }
);

export const getLaunch = (state: RootState): TLauncherDetails | undefined =>
  state.launcher.launcherDetails;
